(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["baby-gut-health-routine"] && !Shopify.designMode) return;
  try {
    
(() => {
  const campaignKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  const initialize = (scope) => {
    const current = new URLSearchParams(window.location.search);
    scope.querySelectorAll('[data-bgr-merchant]').forEach((link) => {
      const destination = new URL(link.href, window.location.origin);
      campaignKeys.forEach((key) => {
        const value = current.get(key);
        if (value) destination.searchParams.set(key, value);
      });
      link.href = destination.href;
    });
    scope.querySelectorAll('[data-bgr-return]').forEach((input) => {
      const destination = new URL('/cart', 'https://nurturebio.com');
      campaignKeys.forEach((key) => {
        const value = current.get(key);
        if (value) destination.searchParams.set(key, value);
      });
      input.value = destination.pathname + destination.search;
    });
    scope.querySelectorAll('.bgr-product-form').forEach((component) => {
      if (component.dataset.bgrInitialized) return;
      component.dataset.bgrInitialized = 'true';
      const form = component.querySelector('form');
      const button = component.querySelector('[data-bgr-add]');
      const status = component.querySelector('[data-bgr-status]');
      const automatic = component.querySelector('[data-bgr-automatic]');
      if (!form || !button || !status) return;
      const update = () => {
        const subscription = form.querySelector('[data-bgr-choice="subscription"]:checked');
        if (!button.disabled) button.textContent = subscription ? button.dataset.subscriptionLabel : button.dataset.onceLabel;
        if (automatic) automatic.hidden = !subscription;
      };
      form.addEventListener('change', () => { update(); status.textContent = ''; });
      form.addEventListener('submit', () => {
        if (form.checkValidity()) status.textContent = button.dataset.adding;
      });
      component.addEventListener('variant:add', () => {
        status.textContent = button.dataset.added;
      });
      component.addEventListener('cart:error', (event) => {
        status.textContent = event.detail?.error || button.dataset.error;
      });
      update();
      window.addEventListener('pageshow', () => { update(); status.textContent = ''; });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["for-moms-lp"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-nbm-page]').forEach((root) => {
      if (root.dataset.nbmInitialized === 'true') return;
      root.dataset.nbmInitialized = 'true';
      document.body.classList.add('nbm-page');
      const form = root.querySelector('[data-nbm-product-form] form');
      const sellingPlanInput = root.querySelector('[data-nbm-selling-plan]');
      const optionInputs = root.querySelectorAll('[data-nbm-option]');
      const buyButton = root.querySelector('[data-nbm-buy-button]');
      const purchaseButtons = root.querySelectorAll('button[type="submit"]');
      const cartLink = root.querySelector('[data-nbm-cart-link]');
      const cartCount = root.querySelector('[data-nbm-cart-count]');
      const quickBuy = root.querySelector('[data-nbm-quick-buy]');
      const fullBuyBox = root.querySelector('[data-nbm-full-buy-box]');
      const sticky = root.querySelector('[data-nbm-sticky]');
      const seenEvents = new Set();
      let pendingPlacement = 'bottom_buy_box';
      let quickBuyVisible = true;
      let fullBuyVisible = false;
      let footerVisible = false;

      const pushEvent = (eventName, placement) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: eventName, page: 'moms_listicle', placement: placement || 'unknown' });
      };
      const pushViewOnce = (eventName, placement) => {
        const key = `${eventName}:${placement}`;
        if (seenEvents.has(key)) return;
        seenEvents.add(key);
        pushEvent(eventName, placement);
      };
      const syncPurchaseOption = (choice) => {
        if (!sellingPlanInput || !buyButton) return;
        const subscription = choice === 'subscription';
        sellingPlanInput.disabled = !subscription;
        sellingPlanInput.value = subscription ? sellingPlanInput.dataset.planId : '';
        buyButton.textContent = subscription ? buyButton.dataset.subscriptionLabel : buyButton.dataset.onetimeLabel;
        root.querySelectorAll('[data-nbm-subscription-only]').forEach((element) => { element.hidden = !subscription; });
        root.querySelectorAll('[data-nbm-onetime-only]').forEach((element) => { element.hidden = subscription; });
        root.dataset.nbmPurchaseChoice = choice;
      };
      const revealTarget = (hash, moveFocus = false) => {
        if (!hash || hash.length < 2) return;
        const target = document.getElementById(hash.slice(1));
        if (!target || !root.contains(target)) return;
        if (target.tagName === 'DETAILS') target.open = true;
        if (moveFocus) {
          const focusTarget = target.tagName === 'DETAILS' ? target.querySelector('summary') : target;
          focusTarget.focus({ preventScroll:true });
          target.scrollIntoView({ block:'start', behavior:'instant' });
        }
      };
      root.querySelectorAll('[data-nbm-jump]').forEach((link) => link.addEventListener('click', (event) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const hash = link.hash;
        if (window.location.hash !== hash) history.pushState(null, '', hash);
        revealTarget(hash, true);
      }));
      window.addEventListener('hashchange', () => revealTarget(window.location.hash, true));
      revealTarget(window.location.hash);
      optionInputs.forEach((input) => input.addEventListener('change', () => {
        if (input.checked) syncPurchaseOption(input.value);
      }));
      root.addEventListener('click', (event) => {
        const tracked = event.target.closest('[data-nbm-track-event]');
        if (tracked) {
          pendingPlacement = tracked.dataset.nbmPlacement || 'unknown';
          pushEvent(tracked.dataset.nbmTrackEvent, pendingPlacement);
        }
        if (!event.target.closest('[data-nbm-force-subscription]')) return;
        const subscriptionOption = root.querySelector('[data-nbm-option][value="subscription"]');
        if (subscriptionOption) subscriptionOption.checked = true;
        syncPurchaseOption('subscription');
      });
      const setButtonsBusy = (busy) => purchaseButtons.forEach((button) => {
        button.disabled = busy;
        button.setAttribute('aria-busy', busy ? 'true' : 'false');
      });
      if (form) form.addEventListener('submit', () => setButtonsBusy(true));
      document.addEventListener('variant:add', (event) => {
        if (!root.contains(event.target)) return;
        setButtonsBusy(false);
        pushEvent('moms_add_to_cart_context', pendingPlacement);
      });
      document.addEventListener('cart:error', (event) => {
        if (root.contains(event.target)) setButtonsBusy(false);
      });
      document.documentElement.addEventListener('cart:change', (event) => {
        if (!cartCount || !event.detail || !event.detail.cart) return;
        const itemCount = event.detail.cart.item_count || 0;
        cartCount.textContent = itemCount;
        if (cartLink) cartLink.setAttribute('aria-label', cartLink.dataset.nbmCartLabel.replace('COUNT', itemCount));
      });

      const isConsentVisible = () => {
        const consent = document.querySelector('#shopify-pc__banner, .shopify-pc__banner__dialog, [data-testid="consent-banner"]');
        return Boolean(consent && consent.getClientRects().length);
      };
      const updateSticky = () => {
        if (!sticky) return;
        const pastQuickBuy = quickBuy && quickBuy.getBoundingClientRect().bottom <= 0;
        const show = window.matchMedia('(max-width:899px)').matches && pastQuickBuy && !quickBuyVisible && !fullBuyVisible && !footerVisible && !isConsentVisible();
        sticky.hidden = !show;
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.body.classList.toggle('nbm-sticky-visible', show);
        if (show) pushViewOnce('sticky_cta_view', 'sticky');
      };
      if ('IntersectionObserver' in window) {
        const viewObserver = new IntersectionObserver((entries) => entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          pushViewOnce(entry.target.dataset.nbmViewEvent, entry.target.dataset.nbmPlacement);
          viewObserver.unobserve(entry.target);
        }), { threshold: .35 });
        root.querySelectorAll('[data-nbm-view-event]').forEach((element) => viewObserver.observe(element));
        const stickyObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target === quickBuy) quickBuyVisible = entry.isIntersecting;
            if (entry.target === fullBuyBox) fullBuyVisible = entry.isIntersecting;
            if (entry.target.tagName === 'FOOTER') footerVisible = entry.isIntersecting;
          });
          updateSticky();
        }, { threshold: 0 });
        if (quickBuy) stickyObserver.observe(quickBuy);
        if (fullBuyBox) stickyObserver.observe(fullBuyBox);
        const footer = document.querySelector('footer');
        if (footer) stickyObserver.observe(footer);
      }

      const suppressKlaviyoPromotion = () => document.querySelectorAll('[data-testid="POPUP"], [data-testid="FLYOUT"]').forEach((promotion) => {
        const closeButton = promotion.querySelector('button[aria-label*="close" i]');
        if (closeButton) closeButton.click();
        promotion.hidden = true;
        promotion.setAttribute('aria-hidden', 'true');
      });
      const pageObserver = new MutationObserver(() => {
        suppressKlaviyoPromotion();
        updateSticky();
      });
      pageObserver.observe(document.body, { childList:true, subtree:true });
      window.addEventListener('resize', updateSticky, { passive:true });
      window.addEventListener('klaviyoForms', (event) => {
        if (event.detail && event.detail.type === 'open') requestAnimationFrame(suppressKlaviyoPromotion);
      });
      syncPurchaseOption('subscription');
      suppressKlaviyoPromotion();
      updateSticky();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-lander-product"] && !Shopify.designMode) return;
  try {
    
  function updateLanderPurchasePrice(section) {
    const selected = section.querySelector('.nb-purchase-options input[name="selling_plan"]:checked');
    const priceBlock = section.querySelector('[data-block-type="price"]');
    const price = priceBlock?.querySelector('sale-price');
    if (!selected || !price || !selected.dataset.displayPrice) return;
    priceBlock.setAttribute('aria-live', 'polite');
    priceBlock.setAttribute('aria-atomic', 'true');
    const quantity = Number(section.querySelector('input[name="quantity"]')?.value || 1);
    if (!Number.isInteger(quantity) || quantity < 1) return;
    const total = Number(selected.dataset.unitPrice) * quantity;
    price.textContent = quantity === 1 ? selected.dataset.displayPrice : new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency: selected.dataset.currency || 'USD'
    }).format(total / 100);

  }
  ['input', 'change'].forEach((name) => document.addEventListener(name, (event) => {
    if (!event.target.matches('.nb-purchase-options input[name="selling_plan"], .nb-lander-product input[name="quantity"]')) return;
    const section = event.target.closest('.nb-lander-product');
    if (section) updateLanderPurchasePrice(section);
  }));
  function initializeLanderPrices() {
    document.querySelectorAll('.nb-lander-product').forEach(updateLanderPurchasePrice);
  }
  initializeLanderPrices();
  window.addEventListener('pageshow', initializeLanderPrices);
  document.addEventListener('shopify:section:load', initializeLanderPrices);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-lander-testimonials"] && !Shopify.designMode) return;
  try {
    
  function refreshParentVideoState(section) {
    let active = false;
    section.querySelectorAll('.nb-reviews__video').forEach((card) => {
      const video = card.querySelector('video');
      if (!video) return;
      const playing = !video.paused && !video.ended;
      active ||= playing;
      card.classList.toggle('is-playing', playing);
      video.controls = playing;
      const button = card.querySelector('.nb-video-start');
      if (button) button.hidden = playing;
    });
    section.classList.toggle('has-playing-video', active);
  }
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('.nb-video-start');
    if (!button) return;
    const video = button.closest('.nb-reviews__video').querySelector('video');
    if (!video) return;
    try {
      await video.play();
    } catch {
      video.controls = true;
      button.hidden = true;
    }
  });
  document.addEventListener('play', (event) => {
    const playing = event.target;
    if (!(playing instanceof HTMLVideoElement) || !playing.closest('.nb-reviews')) return;
    document.querySelectorAll('.nb-reviews video').forEach((video) => {
      if (video !== playing) video.pause();
    });
    refreshParentVideoState(playing.closest('.nb-reviews'));
  }, true);
  ['pause', 'ended'].forEach((name) => document.addEventListener(name, (event) => {
    if (event.target instanceof HTMLVideoElement && event.target.closest('.nb-reviews')) {
      refreshParentVideoState(event.target.closest('.nb-reviews'));
    }
  }, true));

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-review-direction]');
    if (!button) return;
    const track = document.getElementById(button.getAttribute('aria-controls'));
    const card = track?.querySelector('.nb-reviews__card');
    if (!card) return;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    track.scrollBy({ left: Number(button.dataset.reviewDirection) * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  });
  function initializeMobileParentVideos() {
    if (!window.matchMedia('(max-width: 699px)').matches) return;
    document.querySelectorAll('.nb-reviews__track').forEach((track) => {
      if (track.dataset.mobilePositioned) return;
      const card = track.querySelectorAll('.nb-reviews__video')[2];
      if (!card || !track.clientWidth) return;
      track.dataset.mobilePositioned = 'true';
      const cardBounds = card.getBoundingClientRect();
      const trackBounds = track.getBoundingClientRect();
      track.scrollTo({
        left: track.scrollLeft + cardBounds.left - trackBounds.left - (track.clientWidth - cardBounds.width) / 2,
        behavior: 'instant'
      });
    });
  }
  requestAnimationFrame(initializeMobileParentVideos);
  window.addEventListener('load', initializeMobileParentVideos);
  window.matchMedia('(max-width: 699px)').addEventListener('change', initializeMobileParentVideos);
  document.addEventListener('shopify:section:load', () => requestAnimationFrame(initializeMobileParentVideos));
  // Duplicate one set so wrapping has no visible gap or rewind.
  function initializeParentVideoAutoscroll() {
    document.querySelectorAll('.nb-reviews').forEach((section) => {
      if (section.dataset.autoInitialized) return;
      section.dataset.autoInitialized = 'true';
      const track = section.querySelector('.nb-reviews__track');
      const originals = Array.from(track.querySelectorAll('.nb-reviews__video'));
      if (originals.length < 2) return;
      track.dataset.continuous = 'true';
      const copies = originals.map((card) => {
        const copy = card.cloneNode(true);
        copy.removeAttribute('data-shopify-editor-block');
        copy.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
        track.append(copy);
        return copy;
      });
      let idleUntil = 0, last = 0, position = track.scrollLeft;
      const defer = () => { idleUntil = performance.now() + 4000; };
      ['pointerdown', 'touchstart', 'wheel', 'keydown', 'click'].forEach((name) => section.addEventListener(name, defer, { passive: true }));
      function frame(now) {
        if (!section.isConnected) return;
        const dt = Math.min(now - (last || now), 50);
        last = now;
        const bounds = track.getBoundingClientRect();
        const paused = document.hidden || matchMedia('(prefers-reduced-motion: reduce)').matches || now < idleUntil || section.matches(':hover') || section.contains(document.activeElement) || section.querySelector('.is-playing') || bounds.bottom <= 0 || bounds.top >= innerHeight;
        if (paused) {
          position = track.scrollLeft;
        } else {
          const cycle = copies[0].getBoundingClientRect().left - originals[0].getBoundingClientRect().left;
          if (cycle > 0) {
            position = (position + dt * 0.025) % cycle;
            track.scrollLeft = position;
          }
        }
        requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    });
  }
  initializeParentVideoAutoscroll();
  document.addEventListener('shopify:section:load', initializeParentVideoAutoscroll);

  } catch(e) { console.error(e); }
})();
})();
